import type { Phrases } from '../Phrases.d';
import type { IntoxicantOption } from '../../../../../site/parts/notificationFormAnonymous/IntoxicantOption.d';

import React from 'react';
import { useWatch } from 'react-hook-form';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { Span } from '/react4xp/components/Element';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import {
	COMMON_FIELD_NAME,
	SUBSTANCE,
} from '../constants';


export const SubstanceOtherTextField = ({
	intoxicantOptions,
	phrases,
}: {
	intoxicantOptions: IntoxicantOption[];
	phrases: Phrases;
}): React.JSX.Element => {
	const {
		control,
	} =	useFormContext();
	const substance = useWatch({ control, name: COMMON_FIELD_NAME.SUBSTANCE}) as string;
	const isOther = substance === SUBSTANCE.OTHER;
	const isMixture = substance === SUBSTANCE.MIXTURE;
	const isEither = isOther || isMixture;

	const localizedOther = intoxicantOptions.filter(({id}) => id === SUBSTANCE.OTHER)?.[0]?.label;
	if (!localizedOther) throw new Error(`Det er en feil på serveren. Innhold for rusmiddel "${SUBSTANCE.OTHER}" mangler!`);

	const localizedMixture = intoxicantOptions.filter(({id}) => id === SUBSTANCE.MIXTURE)?.[0]?.label;
	if (!localizedMixture) throw new Error(`Det er en feil på serveren. Innhold for rusmiddel "${SUBSTANCE.MIXTURE}" mangler!`);

	const substanceLabel = phrases['notificationForm.common.substanceField.label'];
	const substanceOtherLabel = isOther
		? localizedOther
		: localizedMixture;
	return (
		<TextField
			errorSummaryLabel={`${substanceLabel} - ${substanceOtherLabel}`}
			fullWidth
			label={<Span textSize='lg'>{substanceOtherLabel}</Span>}
			name={COMMON_FIELD_NAME.SUBSTANCE_OTHER}
			showIf={({ watch }) => isEither}
		/>
	);
};

